(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pet-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PetAnalytics) return;
  const configNode = document.getElementById('pet-analytics-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const sectionSelector = config.section_selector || '.shopify-section';
  const isPdp = ['product', 'index'].includes(config.template) || Boolean(document.querySelector('.lp-design-marker'));
  const debug = new URLSearchParams(location.search).get('pet_analytics_debug') === '1';
  const testTraffic = debug || config.role !== 'main' || config.design || location.search.includes('preview_theme_id=');
  const privateSelector = '[data-pet-private],[data-clarity-mask],input,textarea,[contenteditable="true"],form:not([action*="/cart"])';
  const controls = 'a,button,summary,select,[role="button"],[role="tab"],video,img';
  const pageId = crypto.randomUUID();
  const started = performance.now();
  const queue = [];
  const sections = new Map();
  const cleanup = [];
  let allowed = false;
  let running = false;
  let sequence = 0;
  let dropped = 0;
  let lastInput = started;
  let lastTick = started;
  let activeMs = 0;
  let maximumScroll = 0;
  let lastScrollBand = 0;
  let scrollPending = false;
  let hover = null;
  let sentCount = 0;
  let contentHash = '';
  let wasVisible = document.visibilityState === 'visible';
  const milestones = new Set();
  const hash = value => {
    let h = 2166136261;
    for (let i = 0; i < value.length; i++) h = Math.imul(h ^ value.charCodeAt(i), 16777619);
    return (h >>> 0).toString(16).padStart(8, '0');
  };
  const safeToken = value => String(value || '').replace(/[^a-zA-Z0-9_:.\-]/g, '').slice(0, 90);
  const wrapper = document.querySelector('.page-wrapper');
  const scrollElement = () => innerWidth >= 990 && wrapper ? wrapper : document.scrollingElement || document.documentElement;
  const scrollTop = () => scrollElement().scrollTop || 0;
  const viewportHeight = () => scrollElement().clientHeight || innerHeight;
  const height = () => Math.max(scrollElement().scrollHeight, viewportHeight());
  const identity = (node, formMetadata = false) => {
    if (!(node instanceof Element) || node.closest(formMetadata ? '[data-pet-private],[data-clarity-mask]' : privateSelector)) return null;
    const section = node.closest(sectionSelector);
    const sectionId = safeToken(section?.id || 'global');
    const parts = [];
    let current = node;
    while (current && current !== section && current !== document.body && parts.length < 15) {
      let n = 1;
      let sibling = current.previousElementSibling;
      while (sibling) { if (sibling.tagName === current.tagName) n++; sibling = sibling.previousElementSibling; }
      parts.unshift(`${current.tagName.toLowerCase()}:${n}`);
      current = current.parentElement;
    }
    const path = parts.join('/');
    return {
      section_id: sectionId,
      element_id: safeToken(node.dataset.trackId) || hash(`${sectionId}/${path}`),
      element_path: path.length <= 100 ? path : `hash:${hash(path)}`,
      element_kind: node.tagName.toLowerCase(),
    };
  };
  const emit = (name, data = {}) => {
    if (!allowed) return;
    if ((sentCount >= 1500 && name !== 'pdp_engagement') || queue.length >= 100) { dropped++; return; }
    const item = {
      name,
      params: {
        schema_v: config.schema, pageview_id: pageId, page_release: config.release,
        content_hash: contentHash, theme_id: String(config.theme), traffic_type: testTraffic ? 'internal' : 'external',
        elapsed_ms: Math.round(performance.now() - started), sequence: ++sequence,
        ...data,
      },
    };
    queue.push(item);
    sentCount++;
    if (debug) {
      const log = document.getElementById('pet-analytics-debug');
      if (log) log.textContent = JSON.stringify({ status: 'collecting', events: window.PetAnalytics.events.slice(-39).concat(item), dropped });
      window.PetAnalytics.events.push(item);
      if (window.PetAnalytics.events.length > 100) window.PetAnalytics.events.shift();
    }
  };
  const flush = () => {
    if (!allowed || !window.Shopify?.analytics?.publish) return;
    while (queue.length) {
      const batch = queue.splice(0, 20);
      try { window.Shopify.analytics.publish('pet:behaviour', { events: batch }); }
      catch { dropped += batch.length; }
    }
  };
  const on = (target, name, fn, options) => {
    target.addEventListener(name, fn, options);
    cleanup.push(() => target.removeEventListener(name, fn, options));
  };
  const tick = () => {
    const now = performance.now();
    const delta = wasVisible ? Math.max(0, Math.min(now, lastInput + 30000) - lastTick) : 0;
    activeMs += delta;
    for (const state of sections.values()) if (state.visible) state.active += delta;
    lastTick = now;
  };
  const activity = () => { tick(); lastInput = performance.now(); };
  const sectionTotals = () => {
    tick();
    for (const [node, state] of sections) {
      if (state.active > state.sent) {
        emit('pdp_section_time', { section_id: safeToken(node.id), active_ms: Math.round(state.active - state.sent), visits: state.visits });
        state.sent = state.active;
      }
    }
  };
  const summary = reason => {
    sectionTotals();
    emit('pdp_engagement', { active_ms: Math.round(activeMs), max_scroll: maximumScroll, page_height: height(), viewport_w: innerWidth, viewport_h: innerHeight, dropped_events: dropped, reason });
    flush();
  };
  const scanScroll = () => {
    scrollPending = false;
    const percent = Math.min(100, Math.floor(100 * (scrollTop() + viewportHeight()) / height()));
    maximumScroll = Math.max(maximumScroll, percent);
    const band = Math.floor(percent / 10) * 10;
    for (let depth = 10; depth <= band; depth += 10) {
      if (!milestones.has(depth)) { milestones.add(depth); emit('pdp_scroll', { depth, scroll_y: Math.round(scrollTop()), page_height: height(), viewport_h: viewportHeight() }); }
    }
    if (band !== lastScrollBand) {
      emit('pdp_scroll_band', { depth: band, direction: band > lastScrollBand ? 'down' : 'up' });
      lastScrollBand = band;
    }
  };
  const offerState = form => {
    const variant = form?.querySelector('[name="id"]')?.value;
    const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    const plan = form?.querySelector('[name="selling_plan"]')?.value;
    return { variant_id: /^\d+$/.test(variant || '') ? variant : '', quantity: Math.max(0, Math.min(quantity || 1, 1000)), selling_plan: /^\d+$/.test(plan || '') ? plan : '' };
  };
  const start = () => {
    if (running) return;
    running = true;
    lastTick = lastInput = performance.now();
    contentHash = config.template === 'search' ? hash(`search:${config.search_count}`) : hash(Array.from(document.querySelectorAll('#MainContent .shopify-section')).map(node => {
      const copy = node.cloneNode(true);
      copy.querySelectorAll('script,input,textarea,[contenteditable],form:not([action*="/cart"]),[data-pet-private]').forEach(el => el.remove());
      return `${node.id}:${copy.textContent.replace(/\s+/g, ' ').trim()}:${Array.from(copy.querySelectorAll('img')).map(img => img.getAttribute('src')?.split('?')[0]).join(',')}`;
    }).join('|'));
    let pageProduct = { product: config.product, variant: config.variant, price: config.price };
    if (isPdp && !Number(pageProduct.product)) {
      const offers = Array.from(document.querySelectorAll('[data-track-offer][data-product-id][data-variant-id]'));
      const products = new Set(offers.map(node => node.dataset.productId).filter(id => /^\d+$/.test(id)));
      const offer = offers.find(node => Number(node.dataset.quantity) === 1) || offers[0];
      if (products.size === 1 && offer && /^\d+$/.test(offer.dataset.variantId)) {
        const quantity = Number(offer.dataset.quantity || 1);
        const price = Number(offer.dataset.price);
        if (quantity > 0 && Number.isFinite(price) && price >= 0) pageProduct = { product: offer.dataset.productId, variant: offer.dataset.variantId, price: price / quantity };
      }
    }
    emit('pdp_page', { template: config.template, pdp_scope: isPdp ? 1 : 0, product_id: String(pageProduct.product), variant_id: String(pageProduct.variant), price: pageProduct.price / 100, currency: config.currency, viewport_w: innerWidth, viewport_h: innerHeight, page_height: height() });
    if (config.template === 'search' && config.search_performed) emit('pdp_search_results', { result_count: Number(config.search_count || 0), has_results: config.search_count > 0 ? 1 : 0 });
    const forms = new Map();
    const formState = node => {
      if (node?.closest?.('[data-pet-private],[data-clarity-mask]')) return null;
      const form = node?.closest?.('form');
      if (!form || form.closest('[data-pet-private],[data-clarity-mask]')) return null;
      if (forms.has(form)) return forms.get(form);
      if (forms.size >= 20) return null;
      let path;
      try { const url = new URL(form.action, location.href); if (url.origin !== location.origin) return null; path = url.pathname.replace(/\/$/, ''); } catch { return null; }
      const kind = /\/cart\/add$/.test(path) ? 'product' : /\/cart$/.test(path) ? 'cart' : /\/search$/.test(path) ? 'search' : /\/contact$/.test(path) ? (form.querySelector('[name="form_type"]')?.value === 'customer' ? 'newsletter' : 'contact') : '';
      const id = kind && identity(form, true);
      if (!id) return null;
      const state = { id: { section_id: id.section_id, element_id: id.element_id, form_kind: kind }, started: false, attempts: 0, exitSent: false };
      forms.set(form, state);
      return state;
    };
    const startForm = node => {
      const state = formState(node);
      if (state && !state.started) { state.started = true; emit('pdp_form_start', state.id); }
      if (state) state.exitSent = false;
      return state;
    };
    on(document, 'focusin', event => { if (event.target.matches?.('input,select,textarea')) startForm(event.target); });
    on(document, 'input', event => startForm(event.target), { passive: true });
    on(window, 'pagehide', () => {
      for (const state of forms.values()) if (state.started && !state.exitSent) {
        emit('pdp_form_exit', { ...state.id, form_status: state.attempts ? 'submit_attempted' : 'no_submit_attempt', attempts: state.attempts });
        state.exitSent = true;
      }
    });
    const linkDetails = (target, id) => {
      const anchor = target.closest('a[href]');
      if (!anchor) return;
      try {
        const url = new URL(anchor.href, location.href);
        if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return;
        let path = decodeURIComponent(url.pathname);
        const fileExtension = path.match(/\.([a-z0-9]{2,5})$/i)?.[1]?.toLowerCase() || '';
        const download = anchor.hasAttribute('download') || /^(pdf|xlsx?|docx?|txt|rtf|csv|key|pptx?|zip|rar|gz|7z|mp4|mov|mp3|wav)$/.test(fileExtension);
        const outbound = url.origin !== location.origin;
        if (!outbound && !download) return;
        if (/@|\/(?:checkouts?|orders?|account|authentication|password)(?:\/|$)|[a-f0-9]{24,}|\d{9,}/i.test(path)) path = '/redacted';
        emit('pdp_link', { section_id: id.section_id, element_id: id.element_id, link_domain: url.hostname.slice(0, 100), link_path: path.length <= 100 ? path : `hash:${hash(path)}`, link_kind: download ? (outbound ? 'outbound_download' : 'download') : 'outbound', file_extension: download ? safeToken(fileExtension) : '' });
      } catch {}
    };
    document.querySelectorAll('[data-track-offer]').forEach(node => emit('pdp_offer_shown', { offer_id: safeToken(node.dataset.trackOffer), product_id: safeToken(node.dataset.productId), variant_id: safeToken(node.dataset.variantId), price: Number(node.dataset.price || 0) / 100, currency: config.currency }));
    on(document, 'click', event => {
      activity();
      const target = event.target instanceof Element ? event.target.closest(controls) || event.target : null;
      const id = identity(target);
      if (!id) return;
      const rect = target.getBoundingClientRect();
      const position = [event.clientX, event.clientY, scrollTop(), rect.width ? 100 * (event.clientX - rect.left) / rect.width : 0, rect.height ? 100 * (event.clientY - rect.top) / rect.height : 0, innerWidth, viewportHeight()].map(Math.round).join(',');
      emit('pdp_click', { ...id, click_position: position, input_type: event.detail === 0 ? 'keyboard' : event.pointerType || 'pointer', interactive: target.matches(controls) ? 1 : 0 });
      linkDetails(target, id);
      if (target.closest('a,button')?.matches('a[href*="/checkout"],button[name="checkout"]')) { emit('pdp_checkout_attempt', id); flush(); }
    }, { capture: true, passive: true });
    on(document, 'submit', event => {
      const state = startForm(event.target);
      if (state) emit('pdp_form_submit', { ...state.id, attempts: ++state.attempts });
      if (event.target.matches('form[action*="/cart/add"]')) { emit('pdp_cart_attempt', offerState(event.target)); flush(); }
    }, true);
    on(document, 'change', event => {
      activity();
      const node = event.target;
      if (!(node instanceof Element) || node.closest('[data-pet-private],form:not([action*="/cart"])')) return;
      if (node.matches('select') || node.matches('input[name="id"],input[name="quantity"],input[name="selling_plan"],input[type="radio"]') && node.closest('variant-picker,form[action*="/cart"]')) {
        const id = identity(node.closest('variant-picker') || node.parentElement);
        if (id) emit('pdp_control_change', { ...id, ...offerState(node.closest('form')), option_index: node.tagName === 'SELECT' ? node.selectedIndex : -1 });
      }
    });
    on(document, 'toggle', event => { const id = identity(event.target); if (id && event.target.matches('details')) emit('pdp_disclosure', { ...id, open: event.target.open ? 1 : 0 }); }, true);
    on(document, 'pointerover', event => {
      if (event.pointerType !== 'mouse') return;
      const node = event.target.closest?.(controls);
      const id = identity(node);
      if (id && (!hover || hover.node !== node)) { hover = { node, id, at: performance.now() }; }
    }, { passive: true });
    on(document, 'pointerout', event => {
      if (!hover || hover.node.contains(event.relatedTarget)) return;
      const ms = performance.now() - hover.at;
      if (ms >= 500) emit('pdp_hover', { ...hover.id, dwell_ms: Math.round(Math.min(ms, 30000)) });
      hover = null;
    }, { passive: true });
    const videos = new WeakMap();
    const videoState = node => {
      if (!(node instanceof Element) || !node.matches('video') || node.closest(privateSelector)) return null;
      const source = node.currentSrc || node.getAttribute('src') || node.querySelector('source')?.getAttribute('src') || '';
      let state = videos.get(node);
      if (!state || state.source !== source) {
        state = { source, sourceHash: hash(source.split('?')[0]), seen: new Set(), at: performance.now(), position: Number(node.currentTime || 0) };
        videos.set(node, state);
      }
      return state;
    };
    const videoProgress = (node, state, percent) => {
      if (state.seen.has(percent)) return;
      state.seen.add(percent);
      const id = identity(node);
      if (id) emit('pdp_video_progress', { ...id, video_percent: percent, duration_s: Math.round(node.duration), source_hash: state.sourceHash });
    };
    for (const name of ['play', 'pause', 'ended']) on(document, name, event => {
      const node = event.target;
      const state = videoState(node);
      if (!state) return;
      const id = identity(node);
      emit('pdp_video', { ...id, action: name, position_s: Math.round(node.currentTime || 0), duration_s: Number.isFinite(node.duration) ? Math.round(node.duration) : 0, source_hash: state.sourceHash });
      if (name === 'ended' && Number.isFinite(node.duration) && node.duration > 0) videoProgress(node, state, 100);
      state.at = performance.now(); state.position = Number(node.currentTime || 0);
    }, true);
    on(document, 'seeked', event => { const state = videoState(event.target); if (state) { state.position = event.target.currentTime; state.at = performance.now(); } }, true);
    on(document, 'timeupdate', event => {
      const node = event.target;
      const state = videos.get(node);
      if (!state || node.paused || node.seeking || !Number.isFinite(node.duration) || node.duration <= 0) return;
      const elapsed = performance.now() - state.at;
      if (elapsed < 1000) return;
      const position = node.currentTime;
      if (position >= state.position && position - state.position <= elapsed / 1000 * (node.playbackRate || 1) + 1) {
        for (const percent of [10, 25, 50, 75, 90]) if (state.position / node.duration * 100 < percent && position / node.duration * 100 >= percent) videoProgress(node, state, percent);
      }
      state.at = performance.now(); state.position = position;
    }, true);
    on(document, 'slideshow:select', event => {
      const id = identity(event.target);
      if (id) emit('pdp_gallery', { ...id, media_index: Number(event.detail?.index || 0), action: safeToken(event.detail?.trigger) });
    });
    on(document, 'shopify:cart:error', () => emit('pdp_cart_error', { error_type: 'cart_error' }));
    on(window, 'error', event => emit('pdp_error', { error_type: event.target === window ? 'javascript' : 'resource', source_hash: hash(String(event.filename || event.target?.src || '').split('?')[0]), line: Number(event.lineno || 0) }), true);
    on(window, 'unhandledrejection', () => emit('pdp_error', { error_type: 'promise' }));
    on(document, 'scroll', event => { if (event.target !== document && event.target !== scrollElement()) return; activity(); if (!scrollPending) { scrollPending = true; requestAnimationFrame(scanScroll); } }, { capture: true, passive: true });
    on(window, 'resize', () => { if (!scrollPending) { scrollPending = true; requestAnimationFrame(scanScroll); } }, { passive: true });
    on(document, 'keydown', activity, { passive: true });
    on(document, 'pointerdown', activity, { passive: true });
    on(document, 'visibilitychange', () => { tick(); wasVisible = !document.hidden; summary(document.hidden ? 'hidden' : 'visible'); lastTick = performance.now(); hover = null; });
    on(window, 'pagehide', () => summary('pagehide'));
    on(window, 'pageshow', event => { if (event.persisted) { lastTick = lastInput = performance.now(); emit('pdp_resume'); } });
    const observer = new IntersectionObserver(entries => {
      tick();
      for (const entry of entries) {
        const state = sections.get(entry.target);
        const visible = entry.isIntersecting && entry.intersectionRect.height >= Math.min(100, entry.boundingClientRect.height / 2);
        if (visible && !state.visible) { state.visits++; emit('pdp_section_view', { section_id: safeToken(entry.target.id), visits: state.visits, section_y: Math.round(entry.boundingClientRect.top + scrollTop()) }); }
        state.visible = visible;
      }
    }, { threshold: [0, .01, .1, .25, .5, 1] });
    document.querySelector('#MainContent')?.querySelectorAll(sectionSelector).forEach(node => { sections.set(node, { visible: false, active: 0, sent: 0, visits: 0 }); observer.observe(node); });
    cleanup.push(() => observer.disconnect());
    const vitals = {};
    const observe = (type, process) => {
      try { const po = new PerformanceObserver(list => { for (const entry of list.getEntries()) process(entry); }); po.observe({ type, buffered: true }); cleanup.push(() => po.disconnect()); } catch {}
    };
    observe('largest-contentful-paint', entry => { vitals.lcp_ms = Math.round(entry.startTime); });
    observe('layout-shift', entry => { if (!entry.hadRecentInput) vitals.cls_sum = Number(((vitals.cls_sum || 0) + entry.value).toFixed(4)); });
    observe('event', entry => { vitals.max_interaction_ms = Math.max(vitals.max_interaction_ms || 0, entry.duration); });
    const heartbeat = setInterval(() => { if (!document.hidden) summary('interval'); }, 30000);
    const batcher = setInterval(flush, 2000);
    const clock = setInterval(tick, 1000);
    const performanceTimer = setTimeout(() => {
      const nav = performance.getEntriesByType('navigation')[0];
      emit('pdp_performance', { ...vitals, ttfb_ms: Math.round(nav?.responseStart || 0), dom_ready_ms: Math.round(nav?.domContentLoadedEventEnd || 0), sample_at_ms: Math.round(performance.now()) });
    }, 10000);
    cleanup.push(() => { clearInterval(heartbeat); clearInterval(batcher); clearInterval(clock); clearTimeout(performanceTimer); });
    scanScroll();
    flush();
  };
  const privacyCheck = () => {
    const next = Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) && navigator.globalPrivacyControl !== true;
    allowed = next;
    if (window.clarity) {
      window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: next ? 'granted' : 'denied' });
      if (!next) window.clarity('stop');
    }
    if (next) start();
    else {
      queue.length = 0;
      cleanup.splice(0).forEach(fn => fn());
      sections.clear();
      running = false;
      hover = null;
    }
    if (debug) configNode.dataset.status = next ? 'collecting' : 'privacy-blocked';
  };
  window.PetAnalytics = { version: config.release, events: [], flush, status: () => ({ allowed, running, sentCount, dropped }) };
  if (debug) {
    const output = document.createElement('pre');
    output.id = 'pet-analytics-debug';
    output.hidden = true;
    output.textContent = JSON.stringify({ status: 'waiting-for-privacy', events: [] });
    document.body.appendChild(output);
  }
  document.addEventListener('visitorConsentCollected', privacyCheck);
  document.querySelectorAll('[data-pet-privacy]').forEach(button => button.addEventListener('click', () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const value = button.dataset.petPrivacy === 'on';
    const consent = { analytics: value };
    privacy.setTrackingConsent(consent, () => {
      privacyCheck();
      const status = document.querySelector('[data-pet-privacy-status]');
      if (status) status.textContent = value ? 'Optional analytics allowed.' : 'Optional analytics turned off for this browser.';
      if (!value && window.clarity) window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' });
      if (value) location.reload();
    });
  }));
  if (window.Shopify?.customerPrivacy) privacyCheck();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) privacyCheck(); });
})();
  } catch(e) { console.error(e); }
})();

})();
